;(function () {
  'use strict'

  angular.module('contrast.integrations').factory('VSTSService', VSTSService)

  function VSTSService(
    $location,
    $q,
    UserService,
    rulesBugtrackerService,
    ServiceUtils,
    BugtrackerFactory,
    FILTER_GROUPS
  ) {
    'ngInject'

    return {
      getVSTSBugtracker: getVSTSBugtracker,
      addVSTSBugtracker: addVSTSBugtracker,
      editVSTSBugtracker: editVSTSBugtracker,
      testVSTSBugtracker: testVSTSBugtracker,
      testExistingVSTSBugtracker: testExistingVSTSBugtracker,
      getVSTSBugtrackerProjects: getVSTSBugtrackerProjects,
      getExistingVSTSBugtrackerProjects: getExistingVSTSBugtrackerProjects,
      getVSTSBugtrackerProjectSettings: getVSTSBugtrackerProjectSettings,
      getExisitingVSTSBugtrackerProjectSettings:
        getExisitingVSTSBugtrackerProjectSettings,
      getVSTSBugtrackerTeamMembers: getVSTSBugtrackerTeamMembers,
      getVSTSBugtrackerProjectTeams: getVSTSBugtrackerProjectTeams,
      getVSTSBugtrackerTeamAreas: getVSTSBugtrackerTeamAreas,
      getVSTSBugtrackerForVulnerability: getVSTSBugtrackerForVulnerability,
      getVSTSBugtrackerForLibrary: getVSTSBugtrackerForLibrary,
      getVSTSPriorityByTraces: getVSTSPriorityByTraces,

      buildVSTSIntegration: buildVSTSIntegration,
      buildVSTSIntegrationTest: buildVSTSIntegrationTest,
      buildVSTSTwoWayIntegration: buildVSTSTwoWayIntegration,
      buildVSTSIntegrationProjects: buildVSTSIntegrationProjects,
      buildVSTSIntegrationProjectTeams: buildVSTSIntegrationProjectTeams,
      buildVSTSBugtracker: buildVSTSBugtracker,
      buildVSTSProperties: buildVSTSProperties,
      addVSTSIntegration: addVSTSIntegration,
      transformToIntegrationView: transformToIntegrationView
    }

    function getVSTSBugtracker(id) {
      return BugtrackerFactory.getVSTSBugtracker(id)
        .then(function (response) {
          return {
            bugtracker: response.data.bugtracker,
            integrations: response.data.integrations
          }
        })
        .catch(ServiceUtils.handleError)
    }

    function getVSTSBugtrackerProjects(id, data) {
      return BugtrackerFactory.getVSTSBugtrackerProjects(id, data)
        .then(function (response) {
          return response.data.projects
        })
        .catch(ServiceUtils.handleError)
    }

    function getExistingVSTSBugtrackerProjects(id, data) {
      return BugtrackerFactory.getExistingVSTSBugtrackerProjects(id, data)
        .then(function (response) {
          return response.data.projects
        })
        .catch(ServiceUtils.handleError)
    }

    function getVSTSBugtrackerProjectSettings(id) {
      return BugtrackerFactory.getVSTSBugtrackerProjectSettings(id)
        .then(function (response) {
          return response.data.settings
        })
        .catch(ServiceUtils.handleError)
    }

    function getExisitingVSTSBugtrackerProjectSettings(id, data) {
      return BugtrackerFactory.getExisitingVSTSBugtrackerProjectSettings(
        id,
        data
      )
        .then(function (response) {
          return response.data.settings
        })
        .catch(ServiceUtils.handleError)
    }

    function getVSTSBugtrackerTeamMembers(data, id) {
      var promise
      if (id) {
        promise = BugtrackerFactory.getExistingVSTSBugtrackerTeamMembers(
          id,
          data
        )
      } else {
        promise = BugtrackerFactory.getVSTSBugtrackerTeamMembers(data)
      }

      return promise
        .then(function (response) {
          return response.data.members
        })
        .catch(ServiceUtils.handleError)
    }

    function getVSTSBugtrackerProjectTeams(data, id) {
      var promise
      if (id) {
        promise = BugtrackerFactory.getExistingVSTSBugtrackerProjectTeams(
          id,
          data
        )
      } else {
        promise = BugtrackerFactory.getVSTSBugtrackerProjectTeams(data)
      }

      return promise
        .then(function (response) {
          return response.data.teams
        })
        .catch(ServiceUtils.handleError)
    }

    function getVSTSBugtrackerTeamAreas(data, id) {
      var promise
      if (id) {
        promise = BugtrackerFactory.getExistingVSTSBugtrackerTeamAreas(id, data)
      } else {
        promise = BugtrackerFactory.getVSTSBugtrackerTeamAreas(data)
      }

      return promise
        .then(function (response) {
          return {
            defaultArea: response.data.defaultArea,
            areas: response.data.areas
          }
        })
        .catch(ServiceUtils.handleError)
    }

    function addVSTSBugtracker(bugtracker) {
      return BugtrackerFactory.addVSTSBugtracker(bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function editVSTSBugtracker(id, bugtracker) {
      return BugtrackerFactory.editVSTSBugtracker(id, bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function testVSTSBugtracker(bugtracker) {
      return BugtrackerFactory.testVSTSBugtracker(bugtracker).then(
        function (response) {
          return response.data.settings
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    function testExistingVSTSBugtracker(id, bugtracker) {
      return BugtrackerFactory.testExistingVSTSBugtracker(id, bugtracker).then(
        function (response) {
          return response.data.settings
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    function getVSTSBugtrackerForVulnerability(id, appId) {
      return BugtrackerFactory.getVSTSBugtrackerForVulnerability(
        id,
        appId
      ).then(
        function (response) {
          return response.data.bugtracker
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    function getVSTSBugtrackerForLibrary(bugtrackerId) {
      return BugtrackerFactory.getVSTSBugtrackerForLibrary(bugtrackerId)
        .then(ServiceUtils.handleResolve('data.bugtracker'))
        .catch(ServiceUtils.handleError)
    }

    function getVSTSPriorityByTraces(id, traces, appId) {
      return BugtrackerFactory.getVSTSPriorityByTraces(id, traces, appId).then(
        function (response) {
          return response.data.priority
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    // VSTS
    function buildVSTSBugtracker(model) {
      var bugtracker = {}
      bugtracker.name = model.name
      bugtracker.host = model.host
      bugtracker.username = model.username

      bugtracker.applications = model.applications
      bugtracker.all_applications = model.all_applications
      bugtracker.assignee = model.assignee
      bugtracker.issue_type = model.issue_type
      bugtracker.project = model.project
      bugtracker.team = model.team
      bugtracker.area = model.area
      bugtracker.version = model.version
      bugtracker.exclude_sensitive_info = model.exclude_sensitive_info
      bugtracker.send_tags = model.send_tags
      bugtracker.add_prefix_to_issue_title = model.add_prefix_to_issue_title
      bugtracker.auto_create_tickets_enabled = model.auto_create_tickets_enabled

      bugtracker.auto_create_tickets_rules = model.auto_create_tickets_rules
      bugtracker.auto_create_tickets_severities =
        model.auto_create_tickets_severities
      bugtracker.auto_create_tickets_all_rules =
        model.auto_create_tickets_all_rules

      bugtracker.integrations = []

      return bugtracker
    }

    function buildVSTSIntegrationTest(model, basicAuth) {
      var request = {}
      request.name = model.name
      request.host = model.host
      request.version = model.version

      _setVSTSAuth(request, model, basicAuth)

      return request
    }

    function buildVSTSTwoWayIntegration(settings, integrations) {
      settings.integrations = integrations.map(function (item) {
        return {
          issueStatus: item.work_item_state,
          traceStatus: item.trace_status,
          traceSubstatus: item.trace_substatus
        }
      })
    }

    function buildVSTSIntegrationProjects(model, basicAuth, projectId) {
      var request = {}
      request.name = model.name
      request.version = model.version

      _setVSTSAuth(request, model, basicAuth)

      request.host = model.host
      request.project = projectId

      return request
    }

    function buildVSTSIntegrationProjectTeams(
      model,
      basicAuth,
      projectId,
      teamId
    ) {
      var request = {}
      request.name = model.name
      request.version = model.version

      _setVSTSAuth(request, model, basicAuth)

      request.host = model.host
      request.projectId = projectId
      request.teamId = teamId

      return request
    }

    function _setVSTSAuth(request, model, basicAuth) {
      if (basicAuth) {
        request.username = model.username
        request.password = model.password
      } else {
        request.password = model.token
      }
    }

    function buildVSTSIntegration(model, properties, basicAuth) {
      var request = {}
      request.name = model.name
      request.host = model.host

      _setVSTSAuth(request, model, basicAuth)

      if (model.all_applications) {
        request.applications = []
      } else {
        request.applications = _.map(model.applications, 'app_id')
      }

      request.all_applications = model.all_applications

      //build auto create tickets request part
      request.auto_create_tickets_enabled = model.auto_create_tickets_enabled
      request.auto_create_tickets_rules = []
      request.auto_create_tickets_severities = []

      if (!model.auto_create_tickets_enabled) {
        request.auto_create_tickets_all_rules = false
      } else {
        if (model.auto_create_tickets_all_rules) {
          request.auto_create_tickets_all_rules = true
        } else {
          _buildRulesRequestSection(request, model)
          request.auto_create_tickets_all_rules = false
        }
      }

      request.project = model.project.id
      if (model.team) {
        request.team = model.team.id
        request.area = model.area
      } else {
        request.team = undefined
        request.area = undefined
      }
      request.assignee = model.assignee.unique_name
      request.issue_type = model.issue_type.type.name
      request.version = model.version

      if (model.issue_type.default_field) {
        request.priority_critical = properties.priority_critical
        request.priority_high = properties.priority_high
        request.priority_medium = properties.priority_medium
        request.priority_low = properties.priority_low
        request.priority_note = properties.priority_note
      } else {
        request.priority_critical = ''
        request.priority_high = ''
        request.priority_medium = ''
        request.priority_low = ''
        request.priority_note = ''
      }

      request.exclude_sensitive_info = model.exclude_sensitive_info
      request.send_tags = model.send_tags
      request.add_prefix_to_issue_title = model.add_prefix_to_issue_title

      return request
    }

    function buildVSTSProperties(model) {
      var properties = {}
      properties.priority_critical = model.priority_critical
      properties.priority_high = model.priority_high
      properties.priority_medium = model.priority_medium
      properties.priority_low = model.priority_low
      properties.priority_note = model.priority_note

      return properties
    }

    function addVSTSIntegration(data, properties) {
      data.assignee = properties.assignee.display_name
      data.bugtracker_issue_type = properties.issue_type.type.name
      data.priority = properties.priority
    }

    function transformToIntegrationView(integration, rules) {
      var form = {
        name: integration.name,
        host: integration.host,
        username: integration.username,
        password: integration.password,
        token: integration.token,
        applications: integration.applications,
        all_applications: integration.all_applications,
        assignee: integration.assignee,
        issue_type: integration.issue_type,
        project: integration.project,
        team: integration.team,
        area: integration.area,
        version: integration.version,

        auto_create_tickets_enabled: integration.auto_create_tickets_enabled,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: [],
        auto_create_tickets_all_rules:
          integration.auto_create_tickets_all_rules,

        integration: integration.integration,
        integrations: integration.integrations,
        placeholderURL: integration.placeholderURL,
        exclude_sensitive_info: integration.exclude_sensitive_info,
        send_tags: integration.send_tags,
        add_prefix_to_issue_title: integration.add_prefix_to_issue_title
      }

      if (!form.auto_create_tickets_all_rules) {
        rulesBugtrackerService.transformRulesToIntegrationView(
          integration,
          rules,
          form
        )
      }

      return form
    }

    function _buildRulesRequestSection(data, integration) {
      var j, ruleItem
      for (j = 0; j < integration.auto_create_tickets_rules.length; j++) {
        ruleItem = integration.auto_create_tickets_rules[j]
        if (ruleItem.group === FILTER_GROUPS.SEVERITY) {
          data.auto_create_tickets_severities.push(ruleItem.value)
        } else {
          data.auto_create_tickets_rules.push(ruleItem.value)
        }
      }
    }
  }
})()
